const STORAGE_PREFIX = 'prefs:';

export function getUserPreference(page, key, defaultValue) {
  try {
    const stored = localStorage.getItem(`${STORAGE_PREFIX}${page}:${key}`);
    return stored !== null ? stored : defaultValue;
  } catch {
    return defaultValue;
  }
}

export function setUserPreference(page, key, value) {
  try {
    localStorage.setItem(`${STORAGE_PREFIX}${page}:${key}`, String(value));
  } catch {}
}
